// import { observer } from "mobx-react";
// import { useCallback, useEffect, useMemo, useState } from "react";
// import useStore from "../../../../../hooks/useStore";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import {
//   ENERGY_UNITS_1,
//   FORM_FIELDS,
//   FREQUENCY_CONSTANTS,
//   STATIC_GROUPS,
// } from "../../../../../constants/constants";
// import { Accordion, Form } from "react-bootstrap";
// import FormDropdown from "../../../../../components/formDropdown";
// import { useAuth } from "../../../../../context/authProvider";
// import TableBody from "./tableBody";
// import { generateAqiPayload } from "../../../../../utils/helpers";
// import { toJS } from "mobx";
// import GlobalUnitDropDown from "../../../../../components/globalUnitDropDown";
// import RecordExists from "../../../../../components/recordExists";

// const AddEnergyPage = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { formData, groupsFilled, freq, formid, unitGlobal } =
//     location.state || {};

//   const { showAlert } = useAuth();

//   const {
//     userStore: { userData },
//     formStore: {
//       fetchFields,
//       fields,
//       create,
//       recordExists,
//       formExists,
//       setFormExists,
//     },
//     companyStore: { fetchUnits, companyUnit, kpiId, subCatId, catId },
//   } = useStore();
//   //states
//   const [groupPayload, setGroupPayload] = useState([]);
//   const [validate, setValidate] = useState(false);
//   const [expanded, setExpanded] = useState("C");
//   const [editForm, setEditForm] = useState("");
//   const [globalUnit, setGlobalUnit] = useState(unitGlobal || "");
//   const [frequency, setFrequency] = useState({
//     ...FREQUENCY_CONSTANTS,
//     ...freq,
//   });

//   useEffect(() => {
//     fetchFields();
//     fetchUnits();
//   }, [fetchFields, fetchUnits]);

//   const tempGroupPayload = useMemo(
//     () =>
//       formData ||
//       Object.entries(
//         fields?.reduce(
//           (acc, curr) => ({
//             ...acc,
//             [curr.group[0]]: [
//               ...(acc[curr.group[0]] ? acc[curr.group[0]] : []),
//               { ...curr, ...FREQUENCY_CONSTANTS, ...FORM_FIELDS },
//             ],
//           }),
//           {}
//         )
//       ).map(([key, value]) => ({
//         group: key,
//         value: value.sort((a, b) => Number(a.position) - Number(b.position)),
//         label: STATIC_GROUPS.energy[key],
//       })),
//     [fields, formData]
//   );

//   useEffect(() => {
//     setGroupPayload(tempGroupPayload);
//   }, [tempGroupPayload]);

//   const allGroups = useMemo(
//     () => Array.from(new Set(tempGroupPayload?.map(({ group }) => group))),
//     [tempGroupPayload]
//   );

//   useEffect(() => {
//     if (groupsFilled?.length > 0) {
//       setExpanded(allGroups[groupsFilled?.length]);
//     }
//   }, [allGroups, groupsFilled]);

//   const dropdownValidated = useMemo(
//     () =>
//       (() => (frequency.frequencyType === "Daily" ? 2 : 3))() ===
//       Object.values(frequency).filter((e) => e)?.length,
//     [frequency]
//   );

//   const payload = useCallback(
//     (data, frequency) =>
//       generateAqiPayload({
//         data,
//         companyUnit,
//         kpiId,
//         subCatId,
//         catId,
//         companyId: Number(toJS(userData)?.companyId),
//       }).map((ele) => ({ ...ele, ...frequency })),
//     [catId, companyUnit, kpiId, subCatId, userData]
//   );

//   const generateGroupPayload = useCallback(
//     (data) => {
//       return Object.entries(
//         data.reduce(
//           (acc, curr) => ({
//             ...acc,
//             [curr.group]: [...(acc[curr.group] || []), curr],
//           }),
//           []
//         )
//       ).map(([key, values]) => ({
//         kpiId,
//         subCatId,
//         catId,
//         targetValue: values.reduce((a, c) => a + (Number(c.target) || 0), 0),
//         groupName: key,
//         prevValue: values.reduce((a, c) => a + (Number(c.prevValue) || 0), 0),
//         companyUnit: companyUnit,
//         unitId: values.reduce((a, c) => a + (Number(c.unit) || 0), 0),

//         ...frequency,
//       }));
//     },
//     [catId, companyUnit, frequency, kpiId, subCatId]
//   );
//   useEffect(() => {
//     setGroupPayload((prev) =>
//       prev?.map((ele) => ({
//         ...ele,
//         value: ele?.value?.map((e) => ({ ...e, ...frequency })),
//       }))
//     );
//   }, [frequency]);

//   useEffect(() => {
//     if (dropdownValidated & !formid) {
//       recordExists({ frequency, type: "energy" });
//     }
//   }, [dropdownValidated, formid, frequency, recordExists]);

//   useEffect(
//     () => () => {
//       setFormExists();
//     },
//     []
//   );

//   return (
//     <div className="add-water-page">
//       <div className="row">
//         <div className="col-12">
//           <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//             <h4 className="mb-sm-0 font-size-18">Add Energy</h4>
//             <div className="page-title-right">
//               <ol className="breadcrumb m-0">
//                 <li className="breadcrumb-item">
//                   <Link to="/company/energy">Energy List</Link>
//                 </li>
//                 <li className="breadcrumb-item active">Add Energy</li>
//               </ol>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="card p-4">
//         <Form validated={validate}>
//           <FormDropdown
//             frequency={frequency}
//             setFrequency={setFrequency}
//             isDisabled={groupsFilled?.length > 0}
//           />
//           <GlobalUnitDropDown
//             setData={setGroupPayload}
//             filterUnit={ENERGY_UNITS_1}
//             global={globalUnit}
//             setGlobal={setGlobalUnit}
//             disabled={!!unitGlobal}
//           />
//         </Form>
//         {formExists ? (
//           <RecordExists />
//         ) : (
//           <Accordion
//             className="water-table-accordion"
//             defaultActiveKey={"C"}
//             activeKey={expanded}
//             onSelect={(eventKey) => {
//               setExpanded(eventKey);
//               setValidate(false);
//             }}
//           >
//             <div className="table-responsive ">
//               {groupPayload?.map((data, index) => (
//                 <Accordion.Item
//                   key={`${data.group}-accordion-item`}
//                   eventKey={data.group}
//                 >
//                   <Accordion.Header>
//                     <tr style={{ display: "flex", gap: "4px" }}>
//                       <td>{index + 1}</td>
//                       <td colSpan={7}>{data.label}</td>
//                     </tr>
//                   </Accordion.Header>
//                   <Accordion.Body>
//                     <Form
//                       noValidate
//                       validated={validate}
//                       onSubmit={(event) => {
//                         event.preventDefault();
//                         const form = event.target;
//                         if (form.checkValidity() && dropdownValidated) {
//                           create({
//                             payload: payload(data.value, frequency),
//                             groupPayload: generateGroupPayload(data.value),
//                             showAlert,
//                             setEditForm,
//                             navigate,
//                             update: groupsFilled?.includes(data.group),
//                             formId: formid,
//                             totalGroups: groupPayload.length,
//                             frequency,
//                             groupData: groupPayload,
//                             endpoint: "energy",
//                             redirectUrl: "/company/energy",
//                             pageUrl: "/company/energy/add",
//                             globalUnit,
//                           });
//                         } else {
//                           showAlert("Please fill All fields.");
//                         }
//                         setValidate(true);
//                       }}
//                     >
//                       <table className="table align-middle table-bordered table-nowrap mb-0">
//                         <thead>
//                           <tr key={12} className="waterTabletr">
//                             <th key={0}>Sr. No.</th>
//                             <th key={1}>Title</th>
//                             <th key={2}>Unit</th>
//                             <th key={3}>Frequency</th>
//                             <th key={4}>Current Value</th>
//                             <th key={5}>Target Value</th>
//                             <th key={6}>Comment</th>
//                             <th key={8}>Attachment</th>
//                           </tr>
//                         </thead>
//                         <TableBody
//                           data={data}
//                           setData={setGroupPayload}
//                           frequency={frequency}
//                           editForm={editForm}
//                           setEditForm={setEditForm}
//                           allGroups={allGroups}
//                           groupData={groupPayload}
//                         />
//                       </table>
//                     </Form>
//                   </Accordion.Body>
//                 </Accordion.Item>
//               ))}
//             </div>
//           </Accordion>
//         )}
//       </div>
//     </div>
//   );
// };

// export default observer(AddEnergyPage);


import { observer } from "mobx-react";
import { useCallback, useEffect, useMemo, useState } from "react";
import useStore from "../../../../../hooks/useStore";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  ENERGY_UNITS_1,
  FORM_FIELDS,
  FREQUENCY_CONSTANTS,
  STATIC_GROUPS,
} from "../../../../../constants/constants";
import { Accordion, Form } from "react-bootstrap";
import FormDropdown from "../../../../../components/formDropdown";
import { useAuth } from "../../../../../context/authProvider";
import TableBody from "./tableBody";
import { generateAqiPayload } from "../../../../../utils/helpers";
import { toJS } from "mobx";
import GlobalUnitDropDown from "../../../../../components/globalUnitDropDown";
import RecordExists from "../../../../../components/recordExists";

const AddEnergyPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // Defensive fallback for navigation state
  const {
    formData = undefined,
    groupsFilled = [],
    freq = {},
    formid = "",
    unitGlobal = ""
  } = location.state || {};

  const { showAlert } = useAuth();

  const {
    userStore: { userData },
    formStore: {
      fetchFields,
      fields,
      create,
      recordExists,
      formExists,
      setFormExists,
    },
    companyStore: { fetchUnits, companyUnit, kpiId, subCatId, catId, getCompanyUnitName, fetchKpiTarget },
  } = useStore();
  
  //states
  const [groupPayload, setGroupPayload] = useState([]);
  const [validate, setValidate] = useState(false);
  const [expanded, setExpanded] = useState("C");
  const [editForm, setEditForm] = useState("");
  const [globalUnit, setGlobalUnit] = useState(unitGlobal || "");
  const [frequency, setFrequency] = useState({
    ...FREQUENCY_CONSTANTS,
    ...freq,
  });

  useEffect(() => {
    fetchFields();
    fetchUnits();
  }, [fetchFields, fetchUnits]);
  
  useEffect(() => {
    fetchKpiTarget({
        payloadData: {
        kpiId,
        subCatId,
        catId,
        year:
          frequency.frequencyYear ||
          String(new Date(frequency.frequencyDate).getFullYear()),
      }
    });
  }, [catId, kpiId, subCatId, frequency.frequencyYear, frequency.frequencyDate, fetchKpiTarget]);

  const tempGroupPayload = useMemo(
    () => {
      try {
        // Always use fetched fields for rendering forms
        const fieldGroups = Object.entries(
          fields?.reduce(
            (acc, curr) => ({
              ...acc,
              [curr.group?.[0]]: [
                ...(acc[curr.group?.[0]] ? acc[curr.group?.[0]] : []),
                { ...curr, ...FREQUENCY_CONSTANTS, ...FORM_FIELDS },
              ],
            }),
            {}
          ) || {}
        ).map(([key, value]) => ({
          group: key,
          value: Array.isArray(value) ? value.sort((a, b) => Number(a.position || 0) - Number(b.position || 0)) : [],
          label: STATIC_GROUPS?.energy?.[key] || `Group ${key}`,
        }));
        return fieldGroups;
      } catch (error) {
        console.error("Error creating tempGroupPayload:", error);
        return [];
      }
    },
    [fields]
  );

  useEffect(() => {
    setGroupPayload(tempGroupPayload);
  }, [tempGroupPayload]);

  const allGroups = useMemo(
    () => Array.from(new Set(tempGroupPayload?.map(({ group }) => group))),
    [tempGroupPayload]
  );

  useEffect(() => {
    if (groupsFilled?.length > 0) {
      setExpanded(allGroups[groupsFilled?.length]);
    }
  }, [allGroups, groupsFilled]);

const dropdownValidated = useMemo(() => {
  if (!frequency.frequencyType) return false;
  if (frequency.frequencyType === "Daily") {
    return Boolean(frequency.frequencyDate);
  } else if (frequency.frequencyType === "Yearly") {
    return Boolean(frequency.frequencyYear);
  } else if (frequency.frequencyType === "Monthly") {
    return Boolean(frequency.frequencyYear && frequency.frequencyMonth);
  }
  return false;
}, [frequency]);

  const payload = useCallback(
    (data, frequency) =>
      generateAqiPayload({
        data,
        companyUnit,
        kpiId,
        subCatId,
        catId,
        companyId: Number(toJS(userData)?.companyId),
      }).map((ele) => ({ ...ele, ...frequency })),
    [catId, companyUnit, kpiId, subCatId, userData]
  );

  const generateGroupPayload = useCallback(
    (data) => {
      return Object.entries(
        data.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.group]: [...(acc[curr.group] || []), curr],
          }),
          []
        )
      ).map(([key, values]) => ({
        kpiId,
        subCatId,
        catId,
        targetValue: values.reduce((a, c) => a + (Number(c.target) || 0), 0),
        groupName: key,
        prevValue: values.reduce((a, c) => a + (Number(c.prevValue) || 0), 0),
        companyUnit: companyUnit,
        unitId: values.reduce((a, c) => a + (Number(c.unit) || 0), 0),
        ...frequency,
      }));
    },
    [catId, companyUnit, frequency, kpiId, subCatId]
  );

  useEffect(() => {
    setGroupPayload((prev) =>
      prev?.map((ele) => ({
        ...ele,
        value: ele?.value?.map((e) => ({ ...e, ...frequency })),
      }))
    );
  }, [frequency]);

  useEffect(() => {
    if (dropdownValidated && !formid) {
      recordExists({ frequency, type: "energy" });
    }
  }, [dropdownValidated, formid, frequency, recordExists]);

  useEffect(
    () => () => {
      setFormExists();
    },
    []
  );

  return (
    <div className="add-water-page">
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <div>
              <h4 className="mb-sm-0 font-size-18">Add Energy</h4>
              <p className="text-muted mb-0">
                <strong>Company Unit:</strong> {getCompanyUnitName()}
              </p>
            </div>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="/company/energy">Energy List</Link>
                </li>
                <li className="breadcrumb-item active">Add Energy</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div className="card p-4">
        <Form validated={validate}>
          <FormDropdown
            frequency={frequency}
            setFrequency={setFrequency}
            isDisabled={groupsFilled?.length > 0}
          />
          <GlobalUnitDropDown
            setData={setGroupPayload}
            filterUnit={ENERGY_UNITS_1}
            global={globalUnit}
            setGlobal={setGlobalUnit}
            disabled={!!unitGlobal}
          />
        </Form>
        {formExists ? (
          <RecordExists />
        ) : (
          <Accordion
            className="water-table-accordion"
            defaultActiveKey={"C"}
            activeKey={expanded}
            onSelect={(eventKey) => {
              setExpanded(eventKey);
              setValidate(false);
            }}
          >
            <div className="table-responsive ">
              {groupPayload?.map((data, index) => (
                <Accordion.Item
                  key={`${data.group}-accordion-item`}
                  eventKey={data.group}
                >
                  <Accordion.Header>
                    <tr style={{ display: "flex", gap: "4px" }}>
                      <td>{index + 1}</td>
                      <td colSpan={7}>{data.label}</td>
                    </tr>
                  </Accordion.Header>
                  <Accordion.Body>
                    <Form
                      noValidate
                      validated={validate}
                      onSubmit={(event) => {
                        event.preventDefault();
                        const form = event.target;
                        let missingFields = [];
                        if (!dropdownValidated) {
                          if (frequency.frequencyType === "Daily") {
                            if (!frequency.frequencyType) missingFields.push("frequencyType");
                            if (!frequency.frequencyDate) missingFields.push("frequencyDate");
                          } else if (frequency.frequencyType === "Yearly") {
                            if (!frequency.frequencyType) missingFields.push("frequencyType");
                            if (!frequency.frequencyYear) missingFields.push("frequencyYear");
                          } else if (frequency.frequencyType === "Monthly") {
                            if (!frequency.frequencyType) missingFields.push("frequencyType");
                            if (!frequency.frequencyYear) missingFields.push("frequencyYear");
                            if (!frequency.frequencyMonth) missingFields.push("frequencyMonth");
                          } else {
                            missingFields.push("frequencyType");
                          }
                        }
                        if (form.checkValidity() && dropdownValidated) {
                          create({
                            payload: payload(data.value, frequency),
                            groupPayload: generateGroupPayload(data.value),
                            showAlert,
                            setEditForm,
                            navigate,
                            update: groupsFilled?.includes(data.group),
                            formId: formid,
                            totalGroups: groupPayload.length,
                            frequency,
                            groupData: groupPayload,
                            endpoint: "energy",
                            redirectUrl: "/company/energy",
                            pageUrl: "/company/energy/add",
                            globalUnit,
                          });
                        } else {
                          if (missingFields.length > 0) {
                            console.log("Missing fields:", missingFields);
                          }
                          showAlert("Please fill All fields.");
                        }
                        setValidate(true);
                      }}
                    >
                      <table className="table align-middle table-bordered table-nowrap mb-0">
                        <thead>
                          <tr key={12} className="waterTabletr">
                            <th key={0}>Sr. No.</th>
                            <th key={1}>Title</th>
                            <th key={2}>Unit</th>
                            <th key={3}>Frequency</th>
                            <th key={4}>Current Value</th>
                            <th key={5}>Target Value</th>
                            <th key={6}>Comment</th>
                            <th key={8}>Attachment</th>
                          </tr>
                        </thead>
                        <TableBody
                          data={data}
                          setData={setGroupPayload}
                          frequency={frequency}
                          editForm={editForm}
                          setEditForm={setEditForm}
                          allGroups={allGroups}
                          groupData={groupPayload}
                        />
                      </table>
                    </Form>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </div>
          </Accordion>
        )}
      </div>
    </div>
  );
};

export default observer(AddEnergyPage);
